// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1zmCX","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3PHcs","obliqueLine":"membershipbadge_obliqueLine__SwVUo"};